export default "__VITE_ASSET__DuhHrULN__"